import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  public get<R>(key: string, convertFn?: (data: string) => R): R | null {
    const tmpConvertFn =
      typeof convertFn === 'function'
        ? convertFn
        : (data: string) => {
          return JSON.parse(data);
        };
    const rawData = localStorage.getItem(key);
    return rawData != null ? tmpConvertFn(rawData) : null;
  }

  public set<T>(key: string, value: T, convertFn?: (data: T) => string): void {
    const tmpConvertFn =
      typeof convertFn === 'function'
        ? convertFn
        : (data: T) => {
          return JSON.stringify(data);
        };

    localStorage.setItem(key, tmpConvertFn(value));
  }

  public remove(key: string): void {
    localStorage.removeItem(key);
  }

  public clear(): void {
    localStorage.clear();
  }
}
